import * as c from '../constants/actionTypes';

let initialState = {
  paper : {
    editor_level: 'pro',
    word_count: 0,
    doc_name: '',
    doc_cost: 0,
    time_limit: 72,
    extras: [],
    special_instructions: '',
    instructions: '',
    instructions_file: null
  },
  someLevelSelected: false,
  extras_price: 0,
  can_pay: false,
  loading: false,
  pricing: {
    bronze: [],
    silver: [],
    gold: [],
    pro: []
  }
}

const realInitialState = initialState;

export default (state = initialState, action) => {
  switch (action.type) {
    case c.CLEAR_PAPER_SESSION:
      var newState = {};
      newState = Object.assign(newState, initialState);
      return state = Object.assign({}, state, newState);
    case c.UPDATE_PAPER_INPUT:
      var newState = state;
      newState.paper[action.key] = action.body;
      return state = Object.assign({}, state, newState);
    case c.UPDATE_EXTRAS_DIFFERENCE:
      var newState = state;
      newState.extras_price = action.body;
      return state = Object.assign({}, state, newState);
    case c.UPDATE_STEP_2:
      var newState = state;
      newState.paper.time_limit = action.time_limit;
      newState.paper.editor_level = action.editor_level;
      newState.someLevelSelected = true;
      return Object.assign({}, state, newState);
    case "UPDATE_SESSION_STEP1":
      var newState = state;
      if(action.body.body != undefined) // real session
      {
        console.log("got body body from session api");
        console.log(action.body.body.instructions);
        newState.paper.doc_name     = action.body.body.doc_name;
        newState.paper.doc_path     = action.body.body.doc_path;
        newState.paper.word_count   = action.body.body.word_count;  
        newState.paper.doc_id       = action.body.body.doc_id;
        newState.paper.email        = action.body.body.email;
        newState.paper.user_email        = action.body.body.user_email;
        newState.paper.english      = action.body.body.english;
        newState.paper.extras       = action.body.body.extras;
        newState.paper.instructions = action.body.body.instructions;
        newState.paper.instructions_file = action.body.body.instructions_file;
        if(action.body.body.editor_level) {
          newState.paper.editor_level = action.body.body.editor_level;
        }
        if(action.body.body.time_limit) {
          newState.paper.time_limit = action.body.body.time_limit;
        }
      }
      return state = Object.assign({}, state, newState);
    case "UPDATE_SESSION_STEP2":
      var newState = state;
      newState.paper.editor_level = action.body.body.editor_level;
      newState.paper.time_limit   = action.body.body.time_limit;
      return state = Object.assign({}, state, newState);
    case c.UPSELL_EDITOR_LEVEL:
      var newState = state;
      newState.paper.editor_level = action.editor_level;
      return Object.assign({}, state, newState);
    case c.UPSELL_TIME_LIMIT:
      var newState = state;
      newState.paper.time_limit = action.time_limit;
      return Object.assign({}, state, newState);
    case c.DOWNSELL_EDITOR_LEVEL:
      var newState = state;
      newState.paper.editor_level = action.editor_level;
      return Object.assign({}, state, newState);
    case c.DOWNSELL_TIME_LIMIT:
      var newState = state;
      newState.paper.time_limit = action.time_limit;
      return Object.assign({}, state, newState);
    case c.UPDATE_STEP_3:
      var newState = state;
      if(action.extras_array.indexOf(action.extra) > -1){
        var index = action.extras_array.indexOf(action.extra);
        action.extras_array.splice(index, 1);
        newState.paper.extras = action.extras_array;
      }else{
        newState.paper.extras.push(action.extra);
      }
      return Object.assign({}, state, newState);
    case c.UPDATE_STEP_3_SPECIAL_TEXT:
      var newState = state;
      newState.paper.instructions = action.special_text;
      return Object.assign({}, state, newState);
    case c.UPDATE_STEP_3_UPLOAD:
      var newState = state;
      newState.paper.instructions_file = action.file_name;
      return Object.assign({}, state, newState);
    case c.REMOVE_EXTRA:
      var newState = state;
      var newExtras = Array();
      console.log('<--- reducer for removing extra --->')
      console.log(action.extra);
      console.log(action.extras_array);
      for(var i in action.extras_array) {
        if(action.extras_array[i] != action.extra) {
          newExtras.push(action.extras_array[i])
        }
      }
      console.log(newExtras)
      newState.extras = newExtras;
      return Object.assign({}, state, newState);
    case c.UPLOAD_PAPER_REQUEST:
      return state = Object.assign({}, state, {
        loading: action.loading,
        paperLoading: action.loading
      })
    case c.UPLOAD_PAPER_SUCCESS:
      var newState = state;
      newState.paper.doc_name = action.body.data.doc_name;
      newState.paper.doc_id = action.body.data.doc_id;
      newState.loading = action.loading;
      newState.paper.word_count = action.body.data.word_count;
      newState.paper.extras = [];
      return Object.assign({}, state, newState);
    case c.UPLOAD_PAPER_FAILURE:
      var newState = state;
      newState.loading = false;
      newState.paperLoading = false;
      return Object.assign({}, state, newState);
    case c.GET_PAPER:
      var newState = state
      return state = Object.assign({}, state, {
          paper: action.body
      })
    case c.GET_PRICING_REQUEST:
      return state = Object.assign({}, state, {
        loading: action.loading
      })
    case c.GET_PRICING_SUCCESS:
      return state = Object.assign({}, state, {
        loading: action.loading,
        pricing: action.body
      })
    case c.GET_PRICING_FAILURE:
      return state = Object.assign({}, state, {
        loading: action.loading,
        error: action.error
      })
    case c.CANCEL_PAPER_UPLOAD:
      console.log("cancel paper in reducer ")
      // return state = Object.assign({}, state, {
      //   loading: action.loading,
      //   paperLoading: action.loading,
      //   upload: {},
      //   delayed_cancel: true,
      //   paper: {}
      // })
    default:
      return state
  }
}

// var extras_array = ["gradeMyPaper",
//                     "Plagiarism",
//                     ,"CitationCorrection"
//                     ,"Formatting"
//                     ,"Critiques"
//                     ,"extraComments"
//                     ,"ExtraEditing"
//                     ,"ESL"];
// for (var i = 0; i < extras_array.length; i++) {
//   if(this.props.Paper.paper.extras.indexOf(extras_array[i]) > -1){
//     console.log("extra found, ", extras_array[i]);
//   }
// }



// WEBPACK FOOTER //
// ./src/reducers/Paper.js